<template>
    <div>
    <div id="otherworks">
        <h2>Writing</h2>
        <router-link to="/writing/another-story">A Little Off the Wall Humor</router-link>
        <div class="story-text">Momma's got a weird way of doing things ... but just how do we keep this within the family so that our neighbors are none-the-wiser?
            <div class="sidebar-text">A short story by Daniel Field Schmidt.</div></div>
      </div>

    </div>
</template>

<script>
    export default {
        name: "OtherWorks",
        components: {

        },
        data: function () {
            return {

            };
        },

        computed: {

        },


        methods: {
        }
    }
</script>

<style>
    ul.rig {
        list-style: none;
        font-size: 0px;
    }
    ul.rig li {
        display: inline-block;
        padding: 10px;
        border: 1px solid #ddd;
        font-size: 16px;
        font-size: 1rem;
        vertical-align: top;
        box-shadow: 0 0 5px #ddd;
        box-sizing: border-box;
        -moz-box-sizing: border-box;
        -webkit-box-sizing: border-box;
    }
    .story-text {
        text-align: left;
        font-family: Sans-Serif, Arial, Helvetica, Verdana;
    }
    .sidebar-text{
        text-align: left;
        font-style: italic;
        font-size: .85em;
        font-family: Sans-Serif, Arial, Helvetica, Verdana;
        color: darkslategray;
    }
</style>
